import React from 'react';
import { Link } from 'react-router-dom';
import { Event } from '@/types';

interface EventCardProps {
  event: Event;
}

export function EventCard({ event }: EventCardProps) {
  const eventDate = new Date(event.date);
  const isPast = eventDate < new Date();
  const formattedDate = eventDate.toLocaleDateString('en-AU', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

  return (
    <Link to={`/events/${event.event_id}/admin`} className="block">
      <div className="card group cursor-pointer">
        {event.cover_photo_url ? (
          <div className="h-40 overflow-hidden">
            <img
              src={event.cover_photo_url}
              alt={event.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          </div>
        ) : (
          <div className="h-40 gradient-bg flex items-center justify-center">
            <span className="text-white text-4xl font-display font-bold opacity-80">
              {event.name.charAt(0)}
            </span>
          </div>
        )}

        <div className="p-5">
          <div className="flex items-start justify-between gap-2 mb-2">
            <h3 className="font-semibold text-gray-900 text-lg group-hover:text-violet-600 transition-colors line-clamp-1">
              {event.name}
            </h3>
            <span
              className={`shrink-0 text-xs font-medium px-2 py-1 rounded-full ${
                isPast
                  ? 'bg-gray-100 text-gray-600'
                  : 'bg-green-50 text-green-700'
              }`}
            >
              {isPast ? 'Past' : 'Upcoming'}
            </span>
          </div>

          <p className="text-sm text-gray-500 mb-3">{formattedDate}</p>

          <div className="flex items-center justify-between text-sm">
            <span className="text-gray-500">{event.location}</span>
            {event.rsvp_count !== undefined && (
              <span className="font-medium text-violet-600">
                {event.rsvp_count} RSVP{event.rsvp_count !== 1 ? 's' : ''}
              </span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}
